export default "__VITE_ASSET__BFCnd06o__"